
import axios, { AxiosResponse } from 'axios';
import {LoginRequest, LoginResponse} from '../../interface/ILogin';
import Cookies  from 'js-cookie';

import helpers from '../../helpers/index';

import { Response } from '../../interface/IResponse';

export const LoginFunction = async (payload: LoginRequest) : Promise<AxiosResponse<LoginResponse>> => {
    try
    {

        var apiUrl = process.env.REACT_APP_API_URL + "/Login";

        var response : AxiosResponse<LoginResponse> = await axios.post(apiUrl, payload,{
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials : true
        });

        return response;
    }
    catch(error){
        throw error;

    }

}

async function DeleteTokenFunction() : Promise<AxiosResponse<LoginResponse>> {

    try
    {
        var apiUrl = process.env.REACT_APP_API_URL + "/Login/deleteToken";

        console.log('apiUrl:: ', apiUrl);
        var response : AxiosResponse<LoginResponse> = await axios.get(apiUrl, { withCredentials: true });

        return response;
    }
    catch(error){
        throw error;
    }

}

async function DeleteCookiesFunction(){

        document.cookie = 'refreshToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
        document.cookie = 'refreshTokenExpiration=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
        document.cookie = 'username=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
        document.cookie = 'permission=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
        document.cookie = 'role=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
}

function SetLoginTokenFunction(refreshToken: string, refreshTokenExpiration: Date, username: string, permission:string, role: string): void {

    try
    {

        helpers.setCookie("refreshToken", refreshToken, refreshTokenExpiration);
        helpers.setCookie("refreshTokenExpiration", String(refreshTokenExpiration), refreshTokenExpiration);
        helpers.setCookie("username", username, refreshTokenExpiration)
        helpers.setCookie("permission", permission, refreshTokenExpiration);
        helpers.setCookie("role", role, refreshTokenExpiration);

    }
    catch(error){
        throw error;
    }
}



async function ForgotPasswordFunction(input: string) : Promise<AxiosResponse<Response>> {
    try{
        var apiUrl = process.env.REACT_APP_API_URL + "/Users/forgotPassword/" + input;

        var response : AxiosResponse<Response> = await axios.get(apiUrl, { withCredentials: true });

        return response;
    }
    catch(error){
        throw error;
    }

}


const LoginService = {
    Login: LoginFunction,
    DeleteToken: DeleteTokenFunction,
    SetLoginToken: SetLoginTokenFunction,
    DeleteCookies: DeleteCookiesFunction,
    ForgotPassword: ForgotPasswordFunction
};

export default LoginService;